// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".backgroundGray{\n    background-color: #F5F6F8 !important;\n}\n\n.backgroundHeader2{\n    background-color: #EBEEF1;\n    color: #353A44;\n    font-size: 0.8rem;\n}\n#codeLight token.property, .token.class-name, .token.constant, .token.symbol {\n    color: #595959;\n}", ""]);
// Exports
module.exports = exports;
